import React, { useState } from 'react';
import FileUploader from './FileUploader';
import '../styles/FileExplorer.scss';

const FileExplorer = ({
  folder,
  files,
  onCreateFolder,
  onUploadFile,
  onDeleteFile,
}) => {
  const [showCreateFolder, setShowCreateFolder] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');

  const handleCreateFolder = async () => {
    if (newFolderName.trim()) {
      await onCreateFolder(folder.id, newFolderName);
      setNewFolderName('');
      setShowCreateFolder(false);
    }
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString();
  };

  if (!folder) {
    return <div className="file-explorer">No folder selected</div>;
  }

  return (
    <div className="file-explorer">
      <div className="explorer-header">
        <div className="folder-info">
          <h2>📁 {folder.name}</h2>
          {folder.description && <p>{folder.description}</p>}
        </div>
        <div className="explorer-actions">
          {!showCreateFolder && (
            <>
              <button
                className="btn-secondary"
                onClick={() => setShowCreateFolder(true)}
              >
                + New Folder
              </button>
              <FileUploader folderId={folder.id} onUpload={onUploadFile} />
            </>
          )}
        </div>
      </div>

      {showCreateFolder && (
        <div className="create-folder-form">
          <input
            type="text"
            placeholder="Folder name"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') handleCreateFolder();
            }}
            autoFocus
          />
          <button className="btn-primary" onClick={handleCreateFolder}>
            Create
          </button>
          <button
            className="btn-secondary"
            onClick={() => {
              setShowCreateFolder(false);
              setNewFolderName('');
            }}
          >
            Cancel
          </button>
        </div>
      )}

      <div className="files-table">
        {files.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Size</th>
                <th>Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {files.map((file) => (
                <tr key={file.id}>
                  <td className="file-name">📄 {file.name}</td>
                  <td>{file.mimeType || 'Unknown'}</td>
                  <td>{formatFileSize(file.size)}</td>
                  <td>{formatDate(file.createdTime)}</td>
                  <td className="file-actions">
                    <button
                      className="btn-danger btn-sm"
                      onClick={() => {
                        if (window.confirm(`Delete ${file.name}?`)) {
                          onDeleteFile(file.id);
                        }
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="no-files">No files in this folder</p>
        )}
      </div>
    </div>
  );
};

export default FileExplorer;
